import { withLayout } from 'layouts';
import ManageAttendance from './manage-attendance.container';

export default withLayout(ManageAttendance);
